import React from 'react';
import NotificationThreadList from '../NotificationThreadList/NotificationThreadList';
import NotificationThread from '../NotificationThreadDetail/NotificationThread';

/**
 * Memoized version of NotificationThreadList component
 * Prevents unnecessary re-renders when props haven't changed
 */
export const MemoizedNotificationThreadList = React.memo(
    NotificationThreadList,
    (prevProps, nextProps) => {
        // Custom comparison function for better performance
        // Only re-render if these specific props change
        return (
            prevProps.notifications === nextProps.notifications &&
            prevProps.selectedContactGroup === nextProps.selectedContactGroup &&
            prevProps.currentPage === nextProps.currentPage &&
            prevProps.selectedChannels === nextProps.selectedChannels &&
            prevProps.selectedChannelFilter === nextProps.selectedChannelFilter &&
            prevProps.isSearching === nextProps.isSearching &&
            prevProps.hasMore === nextProps.hasMore
        );
    }
);

MemoizedNotificationThreadList.displayName = 'MemoizedNotificationThreadList';

/**
 * Memoized version of NotificationThread component
 * Prevents unnecessary re-renders when props haven't changed
 */
export const MemoizedNotificationThread = React.memo(
    NotificationThread,
    (prevProps, nextProps) => {
        // Custom comparison function for better performance
        return (
            prevProps.selectedNtification === nextProps.selectedNtification &&
            prevProps.selectedNotificationThreadUuid === nextProps.selectedNotificationThreadUuid &&
            prevProps.isCardOpen === nextProps.isCardOpen &&
            prevProps.channels === nextProps.channels &&
            prevProps.notificationThreadStatus === nextProps.notificationThreadStatus &&
            prevProps.emailOnlySubscribers === nextProps.emailOnlySubscribers &&
            prevProps.selectUsersForGroup === nextProps.selectUsersForGroup &&
            prevProps.selectedGroupTitle === nextProps.selectedGroupTitle
        );
    }
);

MemoizedNotificationThread.displayName = 'MemoizedNotificationThread';
